import { useMutation, useQueryClient } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from 'hooks/useOrgId.js';
import { getQueryKey } from './useShopperInformation.js';

/**
 * Hook to block/unblock shoppers
 * @param {*} shopperInformationId The ID of the shopperInformation document
 * @param {*} shopperId The user ID
 */
const useShopperInformationMutation = (shopperInformationId, shopperId) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const queryClient = useQueryClient();

  const baseUrl = `/o/${encodeURIComponent(orgId)}/shopperInformation`;
  const queryKey = getQueryKey(orgId, shopperId);

  return useMutation({
    mutationFn: async (block) => {
      if (typeof block !== 'boolean') {
        throw new Error('Block parameter must be a boolean');
      }
      if (!shopperInformationId) throw new Error('Missing shopperInformationId');
      const agent = await firebase.getAgent();
      return agent[block ? 'post' : 'delete'](`${baseUrl}/${shopperInformationId}/ban`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
};

export default useShopperInformationMutation;
